import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemButton, ListItemIcon, Checkbox } from '@mui/material';
import CustomRowList from 'src/components/ui/list/custom-row-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';
import AvatarTextField from 'src/components/widgets/avatar-textfield';

export const AssignStudentsView = ({ items, onAddSelected, usePhoneView }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleSelect = (id) => {
    setSelectedId((prev) => (prev === id ? null : id));
  };
  
  const allIds = items.map((el) => el.optionId);
  const isAllSelected = selectedIds.length === allIds.length;
  const isIndeterminate = selectedIds.length > 0 && !isAllSelected;

  const handleToggleAll = () => {
    if (isAllSelected || selectedIds.length > 0) {
      setSelectedIds([]);
      onAddSelected?.({}, []);
    } else {
      setSelectedIds(allIds);
      onAddSelected?.({}, [...items]);
    }
  };

  const handleToggleOne = (item) => {
    setSelectedIds((prev) => {
      const isSelected = prev.includes(item.optionId);
      const next = isSelected
        ? prev.filter((id) => id !== item.optionId)
        : [...prev, item.optionId];
  
      const selectedItems = next.map((id) => items.find((el) => el.optionId === id));
  
      onAddSelected?.(item, selectedItems);
  
      return next;
    });
  };

  const renderItem = (item, rowSx, idx) => (
    <ListItem
      key={idx}
      divider
      disablePadding
    >
      <ListItemButton
        selected={selectedId === item.optionId}
        onClick={() => handleSelect(item.optionId)}
        sx={{
          position: 'relative',
          py: 1,
          px: 1,
          ...(selectedId === item.optionId && {
            bgcolor: 'primary.light',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: '2px',
              backgroundColor: 'primary.main',
            },
          }),
        }}
      >
        {/* STT */}
        {!usePhoneView && (
          <ListCellText flex="0 0 5%">
            {idx + 1}
          </ListCellText>
        )}

        {/* Name + Phone (on phone) or Name only (desktop) */}
        <ListCellText flex={usePhoneView ? '0 0 90%' : '0 0 40%'}>
          <AvatarTextField
            avatarName={item.degreeName}
            avatarSx={{ fontSize: '0.925rem' }}
            value={item.name}
            subValue={usePhoneView ? item.phone : undefined}
          />
        </ListCellText>

        {/* Phone + Birthday (desktop only) */}
        {!usePhoneView && (
          <>
            <ListCellText flex="0 0 25%">
              {item.phone}
            </ListCellText>
            <ListCellText flex="0 0 25%">
              {item.birthday}
            </ListCellText>
          </>
        )}

        {/* Checkbox */}
        <ListItemIcon
          sx={{
            width: usePhoneView ? '10%' : '5%',
            minWidth: 0,
            justifyContent: 'right',
            p: 0,
            m: 0,
            '& .MuiCheckbox-root': {
              p: 0,
              m: 0,
            },
          }}
        >
          <Checkbox
            edge="end"
            checked={selectedIds.includes(item.optionId)}
            onChange={() => handleToggleOne(item)}
            onClick={(e) => e.stopPropagation()}
          />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );


  return (
    <CustomRowList
      items={items}
      renderItem={renderItem}
      sx={{ height: '100%' }}
    >
      {/* STT column only on desktop */}
      {!usePhoneView && (
        <HeaderCellText sx={{ width: '5%' }}>Stt</HeaderCellText>
      )}

      {/* Main column: Học viên (name + phone on mobile) */}
      <HeaderCellText sx={{ width: usePhoneView ? '90%' : '40%' }}>
        Học viên
      </HeaderCellText>

      {/* Extra columns only on desktop */}
      {!usePhoneView && (
        <>
          <HeaderCellText sx={{ width: '25%' }}>
            Điện thoại
          </HeaderCellText>
          <HeaderCellText sx={{ width: '25%' }}>
            Sinh nhật
          </HeaderCellText>
        </>
      )}

      {/* Checkbox header */}
      <ListItemIcon
        sx={{
          width: usePhoneView ? '10%' : '5%',
          minWidth: 0,
          justifyContent: 'right',
          p: 0,
          m: 0,
          '& .MuiCheckbox-root': {
            p: 0,
            m: 0,
          },
        }}
      >
        <Checkbox
          edge="end"
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleToggleAll}
        />
      </ListItemIcon>
    </CustomRowList>
  );
};

AssignStudentsView.propTypes = {
  items: PropTypes.array.isRequired,
  onAddSelected: PropTypes.func,
  usePhoneView: PropTypes.bool,
};